import React, { useState, useEffect } from 'react';
import { DollarSign, ShoppingCart, Users, Clock } from 'lucide-react';
import { useAuth } from '../../App';
import { getDashboardStats } from '../../api/stats';
import AdminLayout from './AdminLayout';

const AdminDashboard = () => {
  const { token } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getDashboardStats(token);
        setStats(data);
      } catch (err) {
        console.error('Failed to load stats');
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchStats();
  }, [token]);

  const statCards = [
    { icon: DollarSign, label: 'Przychód', value: `${stats?.total_revenue?.toFixed(2) || 0} zł`, color: 'text-[#10b981]' },
    { icon: ShoppingCart, label: 'Zamówienia', value: stats?.paid_orders || 0, color: 'text-blue-400' },
    { icon: Users, label: 'Subskrybenci', value: stats?.subscribers || 0, color: 'text-purple-400' },
    { icon: Clock, label: 'Oczekujące', value: stats?.pending_orders || 0, color: 'text-yellow-400' },
  ];

  return (
    <AdminLayout title="Dashboard">
      {loading ? (
        <div className="flex justify-center py-12"><div className="spinner"></div></div>
      ) : (
        <>
          {/* Stats Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {statCards.map((stat, i) => (
              <div key={i} className="glass-card p-6" data-testid={`stat-card-${i}`}>
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-xl bg-[#050505] flex items-center justify-center ${stat.color}`}>
                    <stat.icon size={24} />
                  </div>
                  <div>
                    <p className="text-[#6B7280] text-sm">{stat.label}</p>
                    <p className="text-2xl font-bold text-white">{stat.value}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Recent Orders */}
          <div className="glass-card p-6">
            <h2 className="text-lg font-bold text-white mb-4">Ostatnie zamówienia</h2>
            <div className="overflow-x-auto">
              <table className="table-custom">
                <thead>
                  <tr>
                    <th>Nr zamówienia</th>
                    <th>Klient</th>
                    <th>Kwota</th>
                    <th>Status</th>
                    <th>Data</th>
                    <th>Czas (PL)</th>
                  </tr>
                </thead>
                <tbody>
                  {stats?.recent_orders?.length > 0 ? (
                    stats.recent_orders.map((order) => (
                      <tr key={order.id}>
                        <td className="text-white font-medium">
                          <div className="flex items-center gap-2 flex-wrap">
                            {order.order_number}
                            {order.is_company && (
                              <span className="px-2 py-0.5 text-xs bg-yellow-500/20 text-yellow-400 border border-yellow-500/30 rounded font-medium">FAKTURA</span>
                            )}
                          </div>
                        </td>
                        <td className="text-[#9CA3AF]">{order.email}</td>
                        <td className="text-[#10b981] font-medium">{Number(order.total).toFixed(2)} zł</td>
                        <td>
                          <span className={`status-${order.payment_status}`}>
                            {order.payment_status === 'paid' ? 'Opłacone' : order.payment_status === 'pending' ? 'Oczekuje' : order.payment_status === 'free' ? 'Gratis' : 'Błąd'}
                          </span>
                        </td>
                        <td className="text-[#6B7280]">{new Date(order.created_at).toLocaleDateString('pl-PL')}</td>
                        <td className="text-[#6B7280]">{new Date(order.created_at).toLocaleTimeString('pl-PL', { timeZone: 'Europe/Warsaw', hour: '2-digit', minute: '2-digit' })}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center text-[#6B7280] py-8">Brak zamówień</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
};

export default AdminDashboard;